import gql from "graphql-tag";

export const updateKnowledgeBaseSectionMutation = gql`
  mutation updateKnowledgeBaseSection($id: ID!, $name: String!, $visibleForDealers: Boolean) {
    updateKnowledgeBaseSection(id: $id, name: $name, visibleForDealers: $visibleForDealers) {
      id
    }
  }
`;
